import { isFunction } from '../types/function.js';
import * as React from 'react';
import { useState, useMemo, useCallback } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { CSSTransition } from 'react-transition-group';
import { CircleDismissButton } from './CircleDismissButton.js';
import { ConfirmCancellationButton } from './ConfirmCancellationButton.js';
import { DismissingCardContext } from './DismissingCardContext.js';
import { Card, Content, DismissingContainer, DismissedText, ButtonsWrap } from './styles.js';
import { TimerDismissButton } from './TimerDismissButton.js';
import { UndoButton } from './UndoButton.js';

const DismissingCard = ({ className , children , onDismiss , hasUndo =true , hasCircleButton =false , dismissedText , undoButtonText , circleButtonPosition , backgroundColor , borderColor , hasTimeout , confirmCancellationButtonText  })=>{
    const [dismissed, setDismissed] = useState(false);
    const [leaveAnimation, setLeaveAnimation] = useState(false);
    const [height, setHeight] = useState(null);
    const contextValue = useMemo(()=>({
            dismiss: ()=>{
                setDismissed(true);
            },
            undo: ()=>{
                setDismissed(false);
            }
        }), []);
    const handleResize = useCallback((_, newHeight)=>{
        setHeight(newHeight);
    }, []);
    const handleDismiss = useCallback(()=>{
        setLeaveAnimation(true);
        if (onDismiss && isFunction(onDismiss)) {
            onDismiss();
        }
    }, [
        onDismiss
    ]);
    return /*#__PURE__*/ React.createElement(DismissingCardContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ React.createElement(CSSTransition, {
        in: !leaveAnimation,
        enter: false,
        unmountOnExit: true,
        classNames: "dismissing-card",
        timeout: 300
    }, /*#__PURE__*/ React.createElement(Card, {
        testId: "dismissing-card",
        className: className,
        dismissed: dismissed,
        height: height,
        backgroundColor: backgroundColor,
        borderColor: borderColor
    }, /*#__PURE__*/ React.createElement(Content, null, !dismissed && children, !!dismissed && /*#__PURE__*/ React.createElement(DismissingContainer, {
        hasTimeout: hasTimeout
    }, /*#__PURE__*/ React.createElement(DismissedText, {
        hasTimeout: hasTimeout
    }, dismissedText), hasTimeout ? /*#__PURE__*/ React.createElement(React.Fragment, null, hasUndo ? /*#__PURE__*/ React.createElement(UndoButton, null, undoButtonText) : null, /*#__PURE__*/ React.createElement(TimerDismissButton, {
        onDismiss: handleDismiss
    })) : /*#__PURE__*/ React.createElement(ButtonsWrap, null, hasUndo ? /*#__PURE__*/ React.createElement(UndoButton, null, undoButtonText) : null, /*#__PURE__*/ React.createElement(ConfirmCancellationButton, {
        onDismiss: handleDismiss
    }, confirmCancellationButtonText))), /*#__PURE__*/ React.createElement(ReactResizeDetector, {
        handleHeight: true,
        onResize: handleResize,
        refreshMode: "throttle",
        refreshRate: 100
    })), hasCircleButton && !dismissed && /*#__PURE__*/ React.createElement(CircleDismissButton, {
        position: circleButtonPosition
    }))));
};

export { DismissingCard };
